module.exports = __webpack_public_path__ + "img/producer2.08ad1b18.png";